// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FdMZf","colBig":"styles_colBig__2wI6W","colSmall":"styles_colSmall__3qT2O","shopifyNameWrapper":"styles_shopifyNameWrapper__3x7E3"};